import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.adminCashExchange;

export const adminCashExchangesSelector = createSelector(getState, (state) => state.cashExchanges);
export const adminCashExchangesMetaSelector = createSelector(
  getState,
  (state) => state.cashExchangesMeta,
);
export const isLoadingCashExchangesSelector = createSelector(
  getState,
  (state) => state.isLoadingExchanges,
);

export const selectedCashExchangeSelector = createSelector(
  getState,
  (state) => state.selectedCashExchange,
);
export const isLoadingCashExchangeSelector = createSelector(
  getState,
  (state) => state.isLoadingCashExchange,
);

export const adminCashExchangeErrorsSelector = createSelector(getState, (state) => state.errors);
